const $ulReviewList = $("#ul_review_list");

// 배열에서 n개의 랜덤한 요소 추출
const sampleSize = ([...arr], n = 1) => {
  let m = arr.length;
  while (m) {
    const i = Math.floor(Math.random() * m--);
    [arr[m], arr[i]] = [arr[i], arr[m]];
  }
  return arr.slice(0, n);
};

// 이번달 와글바글 사용후기 데이터 요청
$.getJSON("/_data/monthly_board_postscript.json")
  .then(res => {
    // 응답 받아서 렌더링
    const randomReviews = sampleSize(res, 9);

    // list html 문자열 생성
    var listHtml = randomReviews
      .map((review, i) => {
        let previewImg, previewText;
        // 사진파일이 있으면 보여주고, 없으면 노이미지
        if (review["userfile_extra"]) {
          previewImg = "/uploads/board/board_postscript/" + review["userfile_extra"].split("|").shift();
        } else {
          previewImg = "/images/noimage2.jpg";
        }

        // html 태그 치환 및 문자열 자르기
        review["content"] = review["content"].replace(/\&?amp;?|\&?nbsp;?|\n|\r|\n\r/gi, "");
        if (review["content"] !== "" && /Copyright+/gi.exec(review["content"]) === null) {
          previewText = review["content"].slice(0, 70);
        } else {
          previewText = review["subject"];
        }
        return `
  		<li>
			<a href="/community/post_view.html?uid=${review["uid"]}" title="${review["subject"]}">
				<div style="border-radius: 70px;width:100px;height: 100px;background-image:url('${previewImg}');    background-size: cover;">
					<div class="txt" style="margin-left: 100px;">
						<h4>${review["subject"]}</h4>
						<p>${previewText}</p>
					</div>
				</div>
			</a>
		</li>
  `;
      })
      .join("");

    $ulReviewList.html(listHtml);
    return this;
  })
  .then(() => {
    // 롤링 추가
    var review_lst = $(".review_lst").bxSlider({
      mode: "horizontal",
      slideMargin: 0,
      pager: false,
      slideWidth: 300,
      minSlides: 3,
      maxSlides: 3,
      moveSlides: 1,
      controls: false,
      auto: true
    });
    $("#slider-next").click(function() {
      review_lst.goToPrevSlide();
    });
    $("#slider-prev").click(function() {
      review_lst.goToNextSlide();
    });
  });



// WEBPACK FOOTER //
// ./index.js